import React from 'react';

import { SnackbarProvider } from 'notistack';

import AuthProvider from 'context/AuthContext';
import ConfirmationModalProvider from 'context/ConfirmationModalContext';
import UserDataProvider from 'context/UserDataContext';
import UserLogProvider from 'context/UserLogContext/UserLogContext';
import useSourceDigest from 'services/common/useSourceDigest/useSourceDigest';

type Props = { children: React.ReactNode };

const AppProviders: React.FC<Props> = ({ children }) => {
  useSourceDigest();
  const snackBarConfig = {
    maxSnack: 3,
    style: {
      maxWidth: 'calc(100vw - 10px)',
    },
    anchorOrigin: {
      vertical: 'bottom' as const,
      horizontal: 'left' as const,
    },
  };

  return (
    <SnackbarProvider {...snackBarConfig}>
      <AuthProvider>
        <UserLogProvider>
          <ConfirmationModalProvider>
            <UserDataProvider>{children}</UserDataProvider>
          </ConfirmationModalProvider>
        </UserLogProvider>
      </AuthProvider>
    </SnackbarProvider>
  );
};

export default AppProviders;
